export const ENABLE_ACCESS_CODE_SEND_TO_PCS = 'ENABLE_ACCESS_CODE_SEND_TO_PCS';

export function enableAceessCodeSendToPCS(payload) {
    return {type: ENABLE_ACCESS_CODE_SEND_TO_PCS, payload: payload};
}


// WEBPACK FOOTER //
// ./src/_actions/access.code.pcs.actions.js